import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EventTypes } from './models/event-types';
import { ToastEvent } from './models/toast-event';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly SESSION_TOAST_KEY = 'app_toast_notification';

  toastEvents: Observable<ToastEvent>;
  readonly _toastEvents = new Subject<ToastEvent>();

  constructor() {
    this.toastEvents = this._toastEvents.asObservable();
  }

  /**
   * Simpan toast ke session storage
   * @param event Toast event
   */
  private saveToastToSession(event: ToastEvent) {
    sessionStorage.setItem(this.SESSION_TOAST_KEY, JSON.stringify(event));
  }

  /**
   * Ambil toast dari session storage
   */
  getSessionToast(): ToastEvent | null {
    const storedToast = sessionStorage.getItem(this.SESSION_TOAST_KEY);
    return storedToast ? JSON.parse(storedToast) : null;
  }

  /**
   * Hapus toast dari session storage
   */
  clearSessionToast() {
    sessionStorage.removeItem(this.SESSION_TOAST_KEY);
  }

  /**
   * Show success toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showSuccessToast(title: string, message: string) {
    const event = {
      message,
      title,
      type: EventTypes.Success,
    };
    this.saveToastToSession(event);
    this._toastEvents.next(event);
  }

  /**
   * Show info toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showInfoToast(title: string, message: string) {
    const event = {
      message,
      title,
      type: EventTypes.Info,
    };
    this.saveToastToSession(event);
    this._toastEvents.next(event);
  }

  /**
   * Show warning toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showWarningToast(title: string, message: string) {
    const event = {
      message,
      title,
      type: EventTypes.Warning,
    };
    this.saveToastToSession(event);
    this._toastEvents.next(event);
  }

  /**
   * Show error toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showErrorToast(title: string, message: string) {
    const event = {
      message,
      title,
      type: EventTypes.Error,
    };
    this.saveToastToSession(event);
    this._toastEvents.next(event);
  }
}